import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app__body" }
const _hoisted_2 = { class: "gd-user-acknowledgement" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert--success"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tick" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  class: "label-padding",
  "data-auto": "custSARID"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "pt-medium gd-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.custSARID)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("labeltext.ackText")), 1),
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('labeltext.reqID')), 1),
              _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.custSARID), 1),
              _hoisted_7
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "button",
          id: "newSARRequest",
          type: "submit",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToNewForm && _ctx.redirectToNewForm(...args)))
        }, _toDisplayString(_ctx.$t("labeltext.makeNewReq")), 1)
      ])
    ])
  ]))
}